module.exports = __webpack_public_path__ + "static/media/HondaFinancialServices_Logo.5aa4eacf.gif";